import React from "react";
import "../../components/Expense/ExpList.css";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CryptoJS from "crypto-js";

const ExpList = ({ fieldOpsResponse }) => {

  const handleDetailClick = (relocationId) => {
    // navigate(`/FieldOpsExpenseList?Relocation_Id=${relocationId}`);
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(relocationId, key);

    // const url = `/FieldOpsExpenseList?Relocation_Id=${encryptedRelocationID}`;
    // window.open(url, "_blank");
  };

  const handleAddExpenseClick = (relocationId) => {
    // navigate(`/AddFieldOpsExpense?Relocation_Id=${relocationId}`);
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(relocationId, key);

    const url = `/AddFieldOpsExpense?Relocation_Id=${encryptedRelocationID}`;
    window.open(url, "_blank");
  };

  function encryptRelocationID(relocationId, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      relocationId.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  return (
    <div className="container-fluid">
      <div className="expenseList">
        <table className="expenseListTable"
          style={{ marginBottom: "1rem", borderRadius: "17px 15px 0px 0px" }}
        >
          <tr>
            <th
              colSpan={8}
              style={{
                backgroundColor: "#5B489D",
                color: "white",
                fontSize: "20px",
              }}
            >
              {" "}
              Expense List
            </th>
          </tr>
        </table>
        <table className="detailsTable">
         
            <tr className="employeeListHeading">
              <th>S.No.</th>
              <th>Bill No.</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Expense Type</th>
              <th>Job ID</th>
              <th>Details</th>              
            </tr>
          
          
            {fieldOpsResponse !== null ? (
              fieldOpsResponse.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.Expense_Id}</td>
                  <td>{item.Amount}</td>
                  <td>{item.Description}</td>
                  <td>{item.espense_type_name}</td>
                  <td>{item.Job_Id}</td>
                  <td>
                    <a
                      onClick={() => handleDetailClick(item.Expense_Id)}
                      style={{
                        cursor: "pointer",
                        marginLeft: "13px",
                        color: "#6a6a6a",
                        textDecoration: "none",
                      }}
                    >
                      <SearchIcon />
                    </a>
                  </td>                  
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15">No suppliers available</td>
              </tr>
            )}
         
        </table>
      </div>
    </div>
  );
};

export default ExpList;
